import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatWithMask(value: string, mask: string): string {
  const digits = value.replace(/\D/g, "");
  
  let formatted = "";
  let digitIdx = 0;
  
  for (let i = 0; i < mask.length; i++) {
    const maskChar = mask[i];
    if (digitIdx >= digits.length) {
      break;
    }
    
    if (maskChar === "9") {
      formatted += digits[digitIdx];
      digitIdx++;
    } else {
      formatted += maskChar;
    }
  }
  
  return formatted;
}
